import React from 'react';
import { InfoPanel, DynamicResultTable, EntitlementIcon } from '@css-xp/base';
import { NEW_DESIGN_DATE_FORMAT } from '@atlassian/cssxp-typescommon';
import { FormattedDate } from '@css-xp/base/formattedV2';
import { emptyStateProp, NoData } from '@css-xp/ppc-common';
import { CustomPanel } from '@css-xp/ppc-purchase-experience';
import { CartLinkedEntitlementsSchema, CartProductSchema } from '../../../../types';

type Props = {
  linkedProducts: Record<string, CartProductSchema>;
  linkedApps: Record<string, CartLinkedEntitlementsSchema>;
};

export const LinkedEntitlements: React.FC<Props> = ({ linkedProducts, linkedApps }) => {
  const infoPanelLinkedEntitlement = (
    <>All the following subscriptions and the apps will also be affected with this action</>
  );

  const getHead = {
    cells: [
      {
        content: 'Product',
        shouldTruncate: true,
        width: 30,
      },
      {
        content: 'Bill date',
        width: 20,
      },
      {
        content: 'Entitlement number',
        width: 20,
      },
    ],
  };

  const getLinkedProductRowData = () => {
    return Object.values(linkedProducts).map((item: CartProductSchema, index) => {
      const cellData = [
        {
          content: (
            <>
              <EntitlementIcon
                logoId={item?.logoId as string}
                productId={item?.productId as string}
                isCloud={true}
                className="avatar medium"
              />{' '}
              <span className="product-name">{item.name}</span>
            </>
          ),
        },
        {
          content: item?.nextBillDate ? (
            <FormattedDate date={item?.nextBillDate as string} dateFormat={NEW_DESIGN_DATE_FORMAT} />
          ) : (
            <NoData />
          ),
        },
        {
          content: item?.entitlementNumber ? (
            <span className="entitlement-number">{item?.entitlementNumber}</span>
          ) : (
            <NoData />
          ),
        },
      ];

      return {
        key: item.entitlementNumber ? item.entitlementNumber : index.toString(),
        cells: cellData,
      };
    });
  };

  const getLinkedAppsRowData = () => {
    return Object.values(linkedApps).map((item: CartLinkedEntitlementsSchema, index) => {
      const cellData = [
        {
          content: (
            <>
              <EntitlementIcon
                logoId={item?.logoId as string}
                productId={item?.productId as string}
                isCloud={true}
                className="avatar medium"
              />{' '}
              <span className="product-name">{item.name}</span>
            </>
          ),
        },
        {
          content: item?.nextBillDate ? (
            <FormattedDate date={item?.nextBillDate as string} dateFormat={NEW_DESIGN_DATE_FORMAT} />
          ) : (
            <NoData />
          ),
        },
        {
          content: item?.entitlementNumber ? (
            <span className="entitlement-number">{item?.entitlementNumber}</span>
          ) : (
            <NoData />
          ),
        },
      ];

      return {
        key: item.entitlementNumber ? item.entitlementNumber : index.toString(),
        cells: cellData,
      };
    });
  };

  const getRows = () => [...getLinkedProductRowData(), ...getLinkedAppsRowData()];

  return (
    <>
      <InfoPanel type="warning" message={infoPanelLinkedEntitlement} />
      <CustomPanel heading={<>View subscriptions</>} toggleButtonOnLeft noHoverBackground>
        <DynamicResultTable boxShadow={false} head={getHead} rows={getRows()} emptyStateProps={emptyStateProp} />
      </CustomPanel>
    </>
  );
};
